<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        Workshop
      </h1>
    </div>
  </div>

  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหา workshop" name="searchWorkshop"
      [(ngModel)]="search" (keyup)="searching()">
    <lifedi-btn lable="เพิ่ม workshop" (click)="addWorkshop()" customStyle="position: absolute; right: 10%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
  </div>

  <table class="table table-striped" style="width: 95%; margin: 0 auto;">
    <thead>
      <tr class="d-flex">
        <th scope="col" *ngFor="let col of column;" [class]="col.class">{{col.header}}</th>
      </tr>
    </thead>

    <!-- not search -->
    <tbody *ngIf="!isSearch">
      <tr class="d-flex" *ngFor="let workshop of rows; let i = index" (ngModelChange)="refreshSearch()">
        <!-- {{workshop|json}} -->
        <td scope="row" class="col">{{ workshop[column[0].field] }}</td>
        <td scope="row" class="col">
          <a [href]="locationUrl + '/activity/workshop/' + workshop[column[0].field]" target="_blank">
            {{ workshop[column[1].field] }}
          </a>
        </td>
        <td scope="row" class="col-3">
          <span *ngFor="let dt of workshop[column[2].field]; let j = index">
            <span *ngIf="dt.dateTime[0]">
              {{ dt.dateTime[0] | dateTime: 'shortNoTime' }}&nbsp; {{ dt.dateTime[0] | dateTime: 'time' }}
              <span *ngIf="!dt.dateTime[1]">น.</span>
            </span>
            <span *ngIf="dt.dateTime[1]">- {{ dt.dateTime[1] | dateTime: 'time' }} น.</span>
            <br>
          </span>
        </td>
        <td scope="row" class="col">{{ workshop[column[3].field] }}</td>
        <td scope="row" class="col text-success" *ngIf="workshop[column[4].field] === 'true'">เผยแพร่</td>
        <td scope="row" class="col text-danger" *ngIf="workshop[column[4].field] === 'false'">ไม่เผยแพร่</td>
        <td scope="row" class="col-1">
          <!-- Check workshop full -->
          <span *ngIf="workshop[column[5].field] === workshop.WORKSHOP_QTY_LEARNERS" class="text-danger">
            {{ workshop[column[5].field] }} / {{ workshop.WORKSHOP_QTY_LEARNERS }}
          </span>
          <span *ngIf="workshop[column[5].field] !== workshop.WORKSHOP_QTY_LEARNERS">
            {{ workshop[column[5].field] }} / {{ workshop.WORKSHOP_QTY_LEARNERS }}
          </span>
        </td>
        <td scope="row" class="col-1">{{ workshop[column[6].field] | number }} ฿ </td>
        <td scope="row" class="col-1">
          <a style="cursor: pointer;" (click)="edit(workshop[column[0].field])">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
        <td scope="row" class="col-1">
          <a (click)="downloadWorkshop(workshop.WORKSHOP_ID)" style="cursor: pointer;">
            <img src="../../../../assets/employee.png" style="width: 20px;">
          </a>
        </td>
      </tr>
    </tbody>

    <!-- search -->
    <tbody *ngIf="isSearch">
      <tr class="d-flex" *ngFor="let workshop of rows; let i = index" (ngModelChange)="refreshSearch()">
        <td scope="row" class="col">{{ workshop[column[0].field] }}</td>
        <td scope="row" class="col">
          <a [href]="locationUrl + '/activity/workshop/' + workshop[column[0].field]" target="_blank">
            {{ workshop[column[1].field] }}</a>
        </td>
        <td scope="row" class="col-3">
          <span *ngFor="let dt of workshop[column[2].field]; let j = index">
            <span *ngIf="dt.dateTime[0]">
              {{ dt.dateTime[0] | dateTime: 'shortNoTime' }}&nbsp; {{ dt.dateTime[0] | dateTime: 'time' }}
            </span>
            <span *ngIf="dt.dateTime[1]">- {{ dt.dateTime[1] | dateTime: 'time' }} น.</span>
            <br>
          </span>
        </td>
        <td scope="row" class="col">{{ workshop[column[3].field] }}</td>
        <td scope="row" class="col text-success" *ngIf="workshop[column[4].field] === 'true'">เผยแพร่</td>
        <td scope="row" class="col text-danger" *ngIf="workshop[column[4].field] === 'false'">ไม่เผยแพร่</td>
        <!-- <td scope="row" class="col-1">{{ workshop[column[5].field] }}</td> -->
        <td scope="row" class="col-1">
          <!-- Check workshop full -->
          <span *ngIf="workshop[column[5].field] === workshop.WORKSHOP_QTY_LEARNERS" class="text-danger">
            {{ workshop[column[5].field] }} / {{ workshop.WORKSHOP_QTY_LEARNERS }}
          </span>
          <span *ngIf="workshop[column[5].field] !== workshop.WORKSHOP_QTY_LEARNERS">
            {{ workshop[column[5].field] }} / {{ workshop.WORKSHOP_QTY_LEARNERS }}
          </span>
        </td>
        <td scope="row" class="col-1">{{ workshop[column[6].field] | number }} ฿ </td>
        <td scope="row" class="col-1">
          <a style="cursor: pointer;" (click)="edit(workshop[column[0].field])">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
        <td scope="row" class="col-1">
          <a (click)="downloadWorkshop(workshop.WORKSHOP_ID)" style="cursor: pointer;">
            <img src="../../../../assets/employee.png" style="width: 20px;">
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="d-flex justify-content-center p-2">
    <ngb-pagination *ngIf="!isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refresh()">
    </ngb-pagination>
    <ngb-pagination *ngIf="isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refreshSearch()">
    </ngb-pagination>
  </div>
  <select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
    (ngModelChange)="refresh()">
    <option [ngValue]="10">10 items per page</option>
    <option [ngValue]="15">15 items per page</option>
    <option [ngValue]="20">20 items per page</option>
  </select>
</div>
